import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ForfraganForetagBrf = lazy(() => import("@/pages/info/ForfraganForetagBrf"));

export const Route = createFileRoute("/forfragan-foretag-brf")({
  head: () => seoHead("/forfragan-foretag-brf"),
  component: () => <ForfraganForetagBrf />,
});
